// import { getLogger } from 'utils/logger';

import { createSelector } from 'reselect';
import { PAYMENT_METHODS_REDUCER_KEY } from './paymentMethodsReducer';

export const getStore = (state) => state[PAYMENT_METHODS_REDUCER_KEY];
export const getIsLoading = (state) => getStore(state).isLoading;
export const getLoadPending = (state) => getStore(state).loadPending;
export const getError = (state) => getStore(state).error;
export const getResourcesById = (state) => getStore(state).resourcesById;

export const getPreferredPaymentMethods = createSelector(getResourcesById, (paymentMethods) =>
  paymentMethods.filter((paymentMethod) => paymentMethod.defaultMethod),
);

export const getValidPreferredPaymentMethods = createSelector(getPreferredPaymentMethods, (paymentMethods) =>
  paymentMethods.filter(
    (paymentMethod) => paymentMethod.token && !paymentMethod.isDeclined && !paymentMethod.isHardDeclined,
  ),
);

export const getInvalidPreferredPaymentMethods = createSelector(getPreferredPaymentMethods, (paymentMethods) =>
  paymentMethods.filter((paymentMethod) => paymentMethod.isDeclined || paymentMethod.isHardDeclined),
);
